import { apiClient } from "@/lib/api-client";
import type {
  Medication,
  CreateMedicationRequest,
  UpdateMedicationRequest,
} from "@/types/medication";

export function getMedications() {
  return apiClient.get<Medication[]>("/api/customer/profile/medications");
}

export function createMedication(data: CreateMedicationRequest) {
  return apiClient.post<Medication>(
    "/api/customer/profile/medications",
    data
  );
}

export function updateMedication(id: string, data: UpdateMedicationRequest) {
  return apiClient.put<Medication>(
    `/api/customer/profile/medications/${id}`,
    data
  );
}

export function deleteMedication(id: string) {
  return apiClient.delete<void>(`/api/customer/profile/medications/${id}`);
}
